import React, { useState } from 'react';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { useCreateCategoryMutation } from '../slices/categoryApiSlice'; // Update path if needed

const CreateCategoryScreen = () => {
  const [name, setName] = useState('');
  const [subcategories, setSubcategories] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [createCategory, { isLoading, error }] = useCreateCategoryMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    setSuccessMessage('');

    try {
      const categoryData = {
        name,
        subcategories: subcategories
          .split(',')
          .map((sub) => sub.trim())
          .filter(Boolean),
      };

      const result = await createCategory(categoryData).unwrap();
      setSuccessMessage(`Category "${result.name}" created successfully!`);
      setName('');
      setSubcategories('');
    } catch (err) {
      // Error is already handled via RTK Query's `error`
    }
  };

  const getErrorMessage = () => {
    if (error?.status === 400) {
      return error?.data?.message || 'Invalid input';
    }
    return 'An unexpected error occurred.';
  };

  return (
    <Container className="py-5">
      <h2 className="mb-4 text-center">Create New Category</h2>

      {error && <Alert variant="danger">{getErrorMessage()}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

      <Form onSubmit={submitHandler}>
        <Form.Group controlId="name" className="mb-3">
          <Form.Label>Category Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter category name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="subcategories" className="mb-3">
          <Form.Label>Subcategories</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter subcategories, separated by commas"
            value={subcategories}
            onChange={(e) => setSubcategories(e.target.value)}
          />
          <Form.Text className="text-muted">
            Example: Fiction, Mystery, Thriller
          </Form.Text>
        </Form.Group>

        <Button type="submit" variant="primary" disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Creating...
            </>
          ) : (
            'Create Category'
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default CreateCategoryScreen;
